import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth";
import { useOrganizationsClient } from "@/features/organizations/hooks/use-organizations-client";
import { organizationsQueryKeys } from "@/features/organizations/queries/organizations-query-keys";

export function useOrganizationsListQuery() {
  const { customerId, productToken } = useAuth();
  const organizationsClient = useOrganizationsClient();

  return useQuery({
    queryKey: organizationsQueryKeys.list(customerId),
    queryFn: () =>
      organizationsClient.getOrganizationsList({
        productToken: productToken as string,
      }),
    enabled: !!customerId && !!productToken,
    select: (response) => response.data,
  });
}
